import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DiscountApiService } from 'features/discount-code/api/discount-api.service';
import { DiscountQueryKeys } from 'features/discount-code/use-cases/query.keys';

const { createOfferBanner } = DiscountApiService();

export const useUpdateOfferBanner = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: FormData) => {
      return createOfferBanner(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: DiscountQueryKeys.all,
        });
        if (data?.ResponseStatus == 1) {
          message.success('Banner Update successfully');
        } else {
          message.error(data?.ResponseMessage);
        }
      },
    },
  );
};
